import { render, staticRenderFns } from "./DeleteEvidence.vue?vue&type=template&id=15e0820a&scoped=true"
import script from "./DeleteEvidence.vue?vue&type=script&lang=js"
export * from "./DeleteEvidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e0820a",
  null
  
)

export default component.exports